import styled, { keyframes } from 'styled-components';
import { H3, Body3 } from './Common.styles';


const koalaFadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;


const popupExpand = keyframes`
  0% {
    transform: scaleX(0);
    opacity: 0;
  }
  60% {
    opacity: 1;
  }
  100% {
    transform: scaleX(1);
    opacity: 1;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;




export const LeftContainer = styled.div`
    flex: 0 0 30%;
    padding-right:30px;

     @media (max-width: 768px) {
     flex: 0 0 12%;
  }


`;

export const Title = styled.h1`
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
`;

export const Subtitle = styled(Body3)`
    color: #555;
    margin-bottom: 20px;
    line-height:140%;
`;

export const RightContainer = styled.div`
    flex: 0 0 70%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    overflow-y: auto;
    max-height: calc(75vh - 20px);
    padding-right:30px;

    @media (max-width: 768px) {
    flex: 100%;
    padding:20px 0px;
  }
`;

export const SectionTitle = styled(H3)`
    margin-bottom: 10px;
    border: 1px solid #DDE1E6;
    border-radius:8px;
    padding:20px;

     @media (max-width: 768px) {
    width:100%;
  }

`;

export const ProfilePhotoContainer = styled.div`
    padding:20px;    
    justify-content: space-between;
    align-items: flex-start;  
    gap: 20px;
    border: 1px solid #DDE1E6;
    border-radius:8px;

      @media (max-width: 768px) {
    width:100%;
  }
`;

export const ImagePreview = styled.img`
    width: 100px;
    height: 100px;
    border-radius: 50%; 
    background-color: #f0f0f0;
    object-fit: cover; 
    display: block;
    margin-right:30px;
`;

export const ProfileImgWrapper = styled.div`
display:flex;
justify-content: space-between;
margin-top:20px;
width:100%;

  @media (max-width: 768px) {
   display: flex;
flex-direction: column;
gap:24px;
  }


`


export const ImageWrapper = styled.div`
  flex: 0 0 60%;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    flex: none;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    overflow: hidden;
    padding: 0 0;
    box-sizing: border-box;
  }
`;



export const BtnWrapper = styled.div`
display:flex;
align-items: center;
flex-direction: column;
`

export const ImageRequirements = styled.div`
flex: 0 0 40%;
border-left: 1px solid #DDE1E6;
padding-left:30px;
    h3 {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 5px;
    }
    ul {
        margin: 10px;
        padding-left: 20px;
        list-style: disc;
        font-size: 14px;
        color: #666;
    }
`;

export const RemoveBtn = styled.button`
background-color:#fff;
border: 1px solid #fff;
color:#61cbc9;
font-size:14px;
margin-top:10px;
`

export const UserDetailsContainer = styled.form`
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top:20px;
`;

export const InputFieldRow = styled.div`
    display: flex;
    gap: 10px;
`;

export const SuccessMessage = styled.div`
    background-color:rgba(97, 203, 201, 0.6);
    padding:16px;
    font-size: 14px;
    color: #000;
    text-align: center;
    margin-top: 2px;
    border-radius:8px;
    border-left:3px solid rgba(97, 203, 201, 1);
    display: block;

    span {
        font-weight: bold;
    }
`;


export const InputLabel = styled.label`
  font-size: 14px;
  color: #61cbc9;
`;

export const InputGroup = styled.div`
  margin:0;
`;

export const Star = styled.span`
  color: red;
  padding-left: 2px;
`;

export const AvatarBox = styled.div`
  position: relative;
  z-index: 1;
  width: 85px;
  height: 85px;
  border-radius: 50%;
  cursor: pointer;
  overflow: none;
  border: ${({ isSelected }) => (isSelected ? "3px solid #61cbc9" : "2px solid #ccc")};
  transition: 0.2s;

  @media (max-width: 768px) {
    width: 56px;
    height: 56px;
  }
`;


export const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  border-radius: 50%;

  @media (max-width: 768px) {
    width: 48px;
    height: 48px;
  }
`;

export const AvatarCheckmark = styled.div`
  position: absolute;
  bottom: 0px;
  right: -4px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #61cbc9;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 2px white;
  z-index: 999; 
  pointer-events: none;

  span {
    color: white;
    font-size: 12px;
  }

  @media (min-width: 769px) {
    width: 24px;
    height: 24px;

    span {
      font-size: 14px;
    }
  }
`;

export const StyledPopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(53, 53, 53, 0.4);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PopupContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 16px;

  @media (max-width: 480px) {
    align-items: center;
    padding: 12px;
  }
`;


export const StyledPopupBox = styled.div`
  position: relative;
  background: white;
  border-radius: 16px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  max-width: 600px;
  width: 90%;
  display: flex;
  flex-direction: column;
  transform: scaleX(0);
  transform-origin: left;
  opacity: 0;
  animation: ${popupExpand} 0.6s ease-out 0.6s forwards;
  margin: 0 auto; 
`;



export const StyledPopupLeft = styled.div`
  background-color: #bde3e3;
  padding: 16px;
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;

  @media (max-width: 480px) {
    padding: 12px;
  }
`;

export const StyledPopupRight = styled.div`
  background-color: white;
  padding: 16px;
  flex: 2;
  display: flex;
  align-items: center;

  @media (max-width: 480px) {
    padding: 12px;
    font-size: 13px;
  }
`;

export const KoalaImage = styled.img`
  position: absolute;
  width: 200px;
  right: -200px;    
  bottom: -40px;  
  z-index: 200;
  opacity: 0;
  pointer-events: none;
  animation: ${koalaFadeIn} 0.6s ease-out 0s forwards; 

  @media (max-width: 1024px) {
    width: 140px;
    right: -40px;
    bottom: -16px;
  }

  @media (max-width: 768px) {
    width: 120px;
    right: -30px;
    bottom: -120px;
    z-index: 200;
  }

  @media (max-width: 480px) {
    width: 120px;
    right: -30px;
    bottom: -120px;
    z-index: 200;
  }
`;



export const PopupButton = styled.button`
  margin-top: 12px;
  padding: 10px 20px;
  background-color: #61cbc9;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.2);
  z-index: 10;
  opacity: 0;
  animation: ${fadeIn} 0.4s ease-out 1.2s forwards;

  &:hover {
    background-color: rgba(97, 203, 201, 0.9);
    opacity: 0.8;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    padding: 8px 16px;
  }
`;




